import { ID } from '@datorama/akita';
import { MortgageTypes } from '@core/state/mortgage-types';

export interface Mortgage {
  id: ID;
  amount: number;
  cost: number;
  current_amount: number;
  debt_free_pay_off: number;
  duration: number;
  end_date: string;
  financial_company_id: number;
  home_id: number;
  interest: number;
  interest_lock_period: number;
  last_check_date: string;
  life_insurance_id: number;
  mortgage_type: MortgageTypes;
  name: string;
  nhg: number;
  person_id: number;
  saving: number;
  start_date: number;
}

export function createMortgage(params: Partial<Mortgage>) {
  return {

  } as Mortgage;
}
